import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InstitucionalService, InstitucionalItem } from './institucional.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-institucional-form',
  templateUrl: './institucional-form.component.html',
  styleUrls: ['./institucional-form.component.css']
})
export class InstitucionalFormComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  saving = false;
  key: string | null = null;
  item: InstitucionalItem | null = null;

  constructor(
    private fb: FormBuilder,
    private svc: InstitucionalService,
    private notify: NotificationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.paramMap.subscribe(params => {
      this.key = params.get('key');
      if (this.key) {
        this.load();
      }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.minLength(3)]],
      contentHtml: ['', [Validators.required, Validators.minLength(10)]],
      version: ['']
    });
  }

  load(): void {
    if (!this.key) return;
    this.loading = true;
    this.svc.list().subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : res?.data ?? [];
        this.item = data.find((i: InstitucionalItem) => i.key === this.key);
        if (this.item) {
          this.form.patchValue({
            title: this.item.title,
            contentHtml: this.item.contentHtml,
            version: this.item.version || ''
          });
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('[Institucional] erro ao carregar', err);
        this.notify.showError('Erro ao carregar institucional');
        this.loading = false;
      }
    });
  }

  save(): void {
    if (this.form.invalid || !this.key) return;
    this.saving = true;
    const payload = this.form.value;
    this.svc.update(this.key, payload).subscribe({
      next: () => {
        this.notify.showSuccess('Institucional atualizado com sucesso');
        this.router.navigate(['/admin/institucional']);
      },
      error: (err) => {
        console.error('[Institucional] erro ao salvar', err);
        this.notify.showError('Erro ao atualizar institucional');
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/admin/institucional']);
  }
}
